export default __webpack_public_path__ + "static/media/pantalla2.519275c6.png";